var _defs, _sodipodNamedview, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCannons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "572mm",
    height: "297mm",
    viewBox: "0 0 572 297",
    id: "svg889",
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    sodipodiDocname: "cannons.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs883"
  })), _sodipodNamedview || (_sodipodNamedview = /*#__PURE__*/React.createElement("sodipodNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 0.7,
    inkscapeCx: 903.32771,
    inkscapeCy: 198.06767,
    "inkscapeDocument-units": "mm",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "false",
    "inkscapeWindow-width": 3840,
    "inkscapeWindow-height": 2050,
    "inkscapeWindow-x": -12,
    "inkscapeWindow-y": -12,
    "inkscapeWindow-maximized": 1
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata886"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Calque 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 62.199955,28.662592 327.5981,50.59297 323.53692,128.16152 56.311242,104.80973 Z",
    id: "path831",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 26.619662,19.028114 37.46438,3.553528 -6.599412,88.533738 -37.972036,-3.04589 z",
    id: "path829",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 445.48938,59.006607 c 0,0 2.72815,-10.050909 -67.62826,-15.363529 0,0 -55.71076,-5.312624 -56.42866,4.881867 L 316.40701,131.08598 439.746,141.1369 Z",
    id: "path850",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 151.00177,90.301828 V 240.97162 H 504.52753 V 140.45742 H 447.26484 V 124.41574 H 398.93681 V 108.98326 H 350.20262 V 88.068176 Z",
    id: "path852",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path854",
    cx: 217.12634,
    cy: 221.17334,
    r: 55.51046
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path858",
    cx: 216.92326,
    cy: 221.57947,
    r: 18.782959
  }), /*#__PURE__*/React.createElement("circle", {
    r: 55.51046,
    cy: 221.17334,
    cx: 438.08087,
    id: "circle860",
    style: {
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 18.782959,
    cy: 221.57947,
    cx: 437.87784,
    id: "circle862",
    style: {
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#eee60e",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4.05925941,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path864",
    cx: 199.939,
    cy: 89.692642,
    r: 27.006849
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannons);
export default __webpack_public_path__ + "static/media/cannons.e42d87f4c24f4a938c7f128685a762ce.svg";
export { ForwardRef as ReactComponent };